<script>
  import { createEventDispatcher } from "svelte";
  import isEmpty from "lodash/isEmpty";
  import ShowIcon from "@local/assets/icons/show.svg";
  import HideIcon from "@local/assets/icons/hide.svg";
  import BlankIcon from "@local/assets/icons/blank.svg";

  export let hiddenColumns;
  export let customColumns;
  export let standardColumns;

  const dispatch = createEventDispatcher();

  const standard = [
    { label: "Mark", prop: "mark" },
    { label: "Width", prop: "width" },
    { label: "Height", prop: "height" },
    { label: "Type", prop: "type_id" },
    { label: "Description", prop: "description" },
    { label: "Quantity", prop: "quantity" },
    { label: "Est. Area", prop: "cache.area" },
    { label: "Est. Wt.", prop: "cache.weight" },
    { label: "Notes", prop: "notes" },
    { label: "Scope", prop: "scope" },
  ];

  $: sc = standard.filter((c) => standardColumns[c.prop]?.visible !== false);
  $: cc = customColumns.map((c) => ({
    label: c.name,
    prop: `custom_column_data.${c.id}`,
  }));
  $: availableColumns = [...sc, ...cc];

  function toggleColumn(prop) {
    dispatch("toggle-column", { prop, value: !hiddenColumns[prop] });
  }
</script>

<div class="rounded-lg border border-gray-300 p-3 my-2 bg-gray-100 space-y-2">
  <div class="mb-2 font-bold">Visible Columns</div>
  <div class="border border-gray-300 h-36 overflow-y-auto bg-white">
    {#each availableColumns as col}
      <div
        class="px-2 py-0.5 flex items-center hover:bg-gray-100"
        class:text-gray-400={hiddenColumns[col.prop]}>
        <div class="grow">
          {col.label}
        </div>
        <div class="flex-none">
          <button on:click={() => toggleColumn(col.prop)}>
            {#if hiddenColumns[col.prop] === "Mixed"}
              <div class="flex items-center">
                <BlankIcon />
                Mixed
              </div>
            {:else if hiddenColumns[col.prop]}
              <HideIcon />
            {:else}
              <ShowIcon />
            {/if}
          </button>
        </div>
      </div>
    {/each}
  </div>
</div>
